import {
  useCurrentUser,
  useCurriculumList,
} from "@twinkltech/curriculum-architect-domain-hooks";

import { CurriculumList } from "./CurriculumList";

export const CurriculumListContainer = () => {
  const {
    data: curriculumList,
    error: curriculumError,
    isLoading,
  } = useCurriculumList();

  const { data: user, error: userError } = useCurrentUser();

  const isSchoolAccount = ["school", "multi-school"].includes(
    user?.persona.accountType || ""
  );

  return (
    <CurriculumList
      curriculumList={curriculumList}
      error={curriculumError || userError}
      isLoading={isLoading}
      isSchoolAccount={isSchoolAccount}
    />
  );
};
